module.exports = __webpack_public_path__ + "static/Education1-bba72d4f6a40cb91823e78572b897646.png";